module.exports = __webpack_public_path__ + "img/d4af154.jpg";